var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightenedBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1841",
    "data-name": "Rectangle 1841",
    width: 23,
    height: 23,
    transform: "translate(0.127)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2413",
    "data-name": "Group 2413",
    transform: "translate(-0.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2412",
    "data-name": "Group 2412",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49158",
    "data-name": "Path 49158",
    d: "M23.127,11.563A11.563,11.563,0,1,1,11.563,0,11.564,11.564,0,0,1,23.127,11.563",
    fill: "#fdcb28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49159",
    "data-name": "Path 49159",
    d: "M196.1,167.992c-.4,0-.783,0-1.114,0a.591.591,0,0,1-.585-.506l-.253-1.682a5.635,5.635,0,0,0-.93-2.316,4.073,4.073,0,0,1-.693-2.5,4.146,4.146,0,0,1,3.821-3.884q.14-.009.277-.009a4.1,4.1,0,0,1,3.4,6.407,5.983,5.983,0,0,0-.95,2.5l-.231,1.535a.562.562,0,0,1-.523.451h-.1c-.627,0-1.4,0-2.117,0",
    transform: "translate(-185.064 -151.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49160",
    "data-name": "Path 49160",
    d: "M187.048,147.127c-.1,0-.2,0-.3.01a4.489,4.489,0,0,0-3.423,6.984,5.275,5.275,0,0,1,.868,2.158l.253,1.682a.981.981,0,0,0,.964.835l1.111,0c.758,0,1.577,0,2.223,0a.948.948,0,0,0,.9-.78l.231-1.535a5.642,5.642,0,0,1,.887-2.342,4.489,4.489,0,0,0-3.715-7.01m3.076,6.575a6.366,6.366,0,0,0-1.013,2.662l-.231,1.535a.189.189,0,0,1-.142.122H188.6c-.621,0-1.379,0-2.083,0l-1.107,0a.207.207,0,0,1-.2-.178l-.253-1.682a6.015,6.015,0,0,0-.991-2.474,3.69,3.69,0,0,1-.627-2.264,3.755,3.755,0,0,1,3.46-3.518c.084-.006.169-.008.252-.008a3.717,3.717,0,0,1,3.076,5.8",
    transform: "translate(-175.485 -141.427)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49161",
    "data-name": "Path 49161",
    d: "M248.382,467.992h-3.561a.309.309,0,1,1,0-.618h3.561a.309.309,0,1,1,0,.618",
    transform: "translate(-235.039 -449.266)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49162",
    "data-name": "Path 49162",
    d: "M270.358,501.5h-1.672a.309.309,0,1,1,0-.618h1.672a.309.309,0,0,1,0,.618",
    transform: "translate(-257.979 -481.473)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49163",
    "data-name": "Path 49163",
    d: "M260.582,280.681h-.008a.185.185,0,0,1-.178-.193c0-.043.166-4.361-.731-5.77a.185.185,0,0,1,.313-.2c.959,1.507.8,5.8.789,5.984a.185.185,0,0,1-.185.178",
    transform: "translate(-249.577 -263.8)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49164",
    "data-name": "Path 49164",
    d: "M240.009,271.238a1.379,1.379,0,0,1-.448-.053.74.74,0,0,1-.473-.387.624.624,0,0,1,.256-.8.634.634,0,0,1,.823.173.185.185,0,1,1-.3.211.269.269,0,0,0-.339-.061.254.254,0,0,0-.1.318.375.375,0,0,0,.259.2,1.146,1.146,0,0,0,.35.033h.54c.3,0,.594,0,.931,0a.185.185,0,0,1,0,.371h0c-.336,0-.624,0-.927,0h-.563Z",
    transform: "translate(-229.77 -259.457)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49165",
    "data-name": "Path 49165",
    d: "M307.875,280.686a.185.185,0,0,1-.185-.178c-.007-.182-.17-4.478.789-5.984a.185.185,0,0,1,.313.2c-.9,1.409-.733,5.727-.731,5.77a.185.185,0,0,1-.178.193h-.008",
    transform: "translate(-295.754 -263.805)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49166",
    "data-name": "Path 49166",
    d: "M291,271.238h-.563c-.3,0-.591,0-.927,0h0a.185.185,0,0,1,0-.371c.337,0,.626,0,.931,0h.54a1.168,1.168,0,0,0,.35-.033.374.374,0,0,0,.259-.2.254.254,0,0,0-.1-.318.268.268,0,0,0-.339.061.185.185,0,0,1-.3-.212.635.635,0,0,1,.823-.174.624.624,0,0,1,.256.8.739.739,0,0,1-.473.387,1.377,1.377,0,0,1-.448.053",
    transform: "translate(-278.116 -259.457)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49167",
    "data-name": "Path 49167",
    d: "M291.782,71.07a.27.27,0,0,1-.27-.27V69.346a.27.27,0,0,1,.541,0V70.8a.27.27,0,0,1-.27.27",
    transform: "translate(-280.218 -66.4)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49168",
    "data-name": "Path 49168",
    d: "M161.272,125.087a.269.269,0,0,1-.191-.079l-1.028-1.028a.27.27,0,1,1,.382-.382l1.028,1.028a.27.27,0,0,1-.191.461",
    transform: "translate(-153.775 -118.733)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49169",
    "data-name": "Path 49169",
    d: "M396.758,125.161a.27.27,0,0,1-.191-.461l1.028-1.028a.27.27,0,0,1,.382.382l-1.028,1.028a.269.269,0,0,1-.191.079",
    transform: "translate(-381.126 -118.804)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49170",
    "data-name": "Path 49170",
    d: "M441.639,255.619h-1.454a.27.27,0,0,1,0-.541h1.454a.27.27,0,1,1,0,.541",
    transform: "translate(-422.871 -245.195)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49171",
    "data-name": "Path 49171",
    d: "M107.251,256.341H105.8a.27.27,0,1,1,0-.541h1.454a.27.27,0,1,1,0,.541",
    transform: "translate(-101.438 -245.889)",
    fill: "#1d1d1d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightenedBulb);
export default __webpack_public_path__ + "static/media/Lightened-Bulb.69ddcfa5384657d8b290a08d7715f10b.svg";
export { ForwardRef as ReactComponent };